<template>
  <main class="bg-background">
    <div
      v-if="!logged"
      class="py-5"
    >
      Error: you must install the
      <a
        href="https://chrome.google.com/webstore/detail/grasp-compliant-media-buy/gnncjalmnfmdilagegplkkckngolohof?hl=fr&authuser=1"
        target="_blank"
        class="text-blue underline"
        >Grasp extension</a
      >
      and log in with your credentials
    </div>
    <template v-else>
      <div
        v-if="!path"
        class="flex w-full flex-col items-center"
      >
        <div class="w-full bg-white">
          <h3 class="my-8 text-center text-xl">Select a platform:</h3>
        </div>
        <div class="mt-8 flex max-w-[660px] space-y-10">
          <div
            v-for="(parent, key) in list"
            :key="key"
          >
            <div class="mb-2 ml-6 text-xl">
              {{ parent.label }}
            </div>
            <div class="flex">
              <div
                v-for="(item, keyItem) in parent.children"
                :key="keyItem"
                class="item-network m-6 inline-flex h-[100px] w-[170px] cursor-pointer flex-col items-center justify-center space-y-2 rounded shadow"
                :style="{
                  background:
                    item.network === 'fb'
                      ? 'linear-gradient(90deg, rgb(33, 117, 207) 30%, rgb(193, 45, 118) 93%)'
                      : item.color,
                }"
                flat
                @click="changePath(item)"
              >
                <div class="mt-2 flex space-x-5">
                  <img
                    class="h-[25px]"
                    :src="images[`icon-${item.network}.svg`]"
                  />
                  <img
                    v-if="item.network === 'twitter'"
                    class="h-[25px]"
                    :src="images[`icon-linkedin.svg`]"
                  />
                </div>
                <label class="cursor-pointer text-center text-white">{{
                  item.label
                }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <iframe
        v-else
        :src="`${origin}/taxonomies/build/${path}&client=abinbev`"
        allow="clipboard-read; clipboard-write"
        title=""
      />
    </template>
  </main>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

const logged = ref(window.location.origin === 'https://localhost:8090');

const assets = import.meta.glob('@grasp-gg/web-ab-inbev/assets/*.svg', {
  eager: true,
  query: '?url',
  import: 'default',
});

const images = Object.keys(assets).reduce(
  (acc, key) => ({
    ...acc,
    [key.split('/').pop() ?? '']: assets[key] as string,
  }),
  {} as Record<string, string>,
);

const route = useRoute();

const path = ref();

const origin = ref(
  window.location.origin === 'https://localhost:8090'
    ? 'https://localhost:8080'
    : 'https://app.grasp.gg',
);

const changePath = (value: {
  label: string;
  path: string;
  custom_path?: Record<string, string>;
}) => {
  if (
    route.query.country &&
    value.custom_path?.[route.query.country as string]
  ) {
    path.value = value.custom_path?.[route.query.country as string];
  } else {
    path.value = value.path;
  }

  window.history.pushState(
    { pageTitle: value.label },
    '',
    `?path=${encodeURIComponent(path.value)}`,
  );
};

onMounted(() => {
  if (route.query.path) {
    path.value = decodeURI(route.query.path as string);
  }

  window.addEventListener('message', (event) => {
    if (event.data.newPath) {
      if (event.data.newPath === '/') {
        document.location = `/${route.query.country ? `?country=${route.query.country}` : ''}`;

        return;
      }

      if (event.data.blank) {
        window.open(`?path=${event.data.newPath}`);

        return;
      }

      changePath({
        label: 'Session',
        path: event.data.newPath,
      });
    }
  });
});

const list = [
  {
    label: 'Social',
    children: [
      {
        label: 'Meta',
        path: 'org_75a949708670404p23s8g990/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=FBK',
        custom_path: {
          us: 'org_a95ss6pp11s3ss020s73spa7/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=FBK',
          mx: 'org_15gr63156p2grs6a206p295a/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=FBK',
          maz: 'org_041ap166r82p957197r91532/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=FBK',
          eu: 'org_p453r3arps4s32gpr5gr4s1a/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=FBK',
          co: 'org_70p6p7543178r35g49204259/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=FBK',
          ca: 'org_2164r5gg20803g2552p73782/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=FBK',
          br: 'org_75a949708670404p23s8g990/hierarchy/template-group/tgt_sag50280a0p1692as8a3rra7?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=FBK',
          af: 'org_55s7671124gp60969g1a1191/hierarchy/template-group/tgt_7a167pg671p795p5385ars39?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=FBK',
        },
        network: 'fb',
        color: '#2175cf',
      },
      {
        label: 'Google',
        path: 'org_75a949708670404p23s8g990/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=YTB',
        custom_path: {
          us: 'org_a95ss6pp11s3ss020s73spa7/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=YTB',
          mx: 'org_15gr63156p2grs6a206p295a/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=YTB',
          maz: 'org_041ap166r82p957197r91532/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=YTB',
          eu: 'org_p453r3arps4s32gpr5gr4s1a/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=YTB',
          co: 'org_70p6p7543178r35g49204259/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=YTB',
          ca: 'org_2164r5gg20803g2552p73782/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=YTB',
          br: 'org_75a949708670404p23s8g990/hierarchy/template-group/tgt_sag50280a0p1692as8a3rra7?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=YTB',
          af: 'org_55s7671124gp60969g1a1191/hierarchy/template-group/tgt_7a167pg671p795p5385ars39?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=YTB',
        },
        network: 'google',
        color: '#d03d3e',
      },
      // {
      //   label: 'Pinterest',
      //   path: 'org_75a949708670404p23s8g990/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=PNT',
      //   custom_path: {
      //     us: 'org_a95ss6pp11s3ss020s73spa7/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=PNT',
      //     mx: 'org_15gr63156p2grs6a206p295a/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=PNT',
      //   },
      //   network: 'pinterest',
      //   color: '#c4232d',
      // },
      // {
      //   label: 'Snapchat',
      //   path: 'org_75a949708670404p23s8g990/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=SNP',
      //   custom_path: {
      //     us: 'org_a95ss6pp11s3ss020s73spa7/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=SNP',
      //     mx: 'org_15gr63156p2grs6a206p295a/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=SNP',
      //   },
      //   network: 'snapchat',
      //   color: '#f4d532',
      // },
      {
        label: 'Twitter/LinkedIn',
        path: 'org_75a949708670404p23s8g990/hierarchy/template-group/tgt_p4rap2s66225119r408873s8?',
        custom_path: {
          us: 'org_a95ss6pp11s3ss020s73spa7/hierarchy/template-group/tgt_p4rap2s66225119r408873s8?',
          mx: 'org_15gr63156p2grs6a206p295a/hierarchy/template-group/tgt_p4rap2s66225119r408873s8?',
          maz: 'org_041ap166r82p957197r91532/hierarchy/template-group/tgt_p4rap2s66225119r408873s8?',
          eu: 'org_p453r3arps4s32gpr5gr4s1a/hierarchy/template-group/tgt_p4rap2s66225119r408873s8?',
          co: 'org_70p6p7543178r35g49204259/hierarchy/template-group/tgt_p4rap2s66225119r408873s8?',
          ca: 'org_2164r5gg20803g2552p73782/hierarchy/template-group/tgt_p4rap2s66225119r408873s8?',
          br: 'org_75a949708670404p23s8g990/hierarchy/template-group/tgt_8a4ra8sas965ssr5r86428s8?',
          af: 'org_55s7671124gp60969g1a1191/hierarchy/template-group/tgt_8a4ra8sas965ssr5r86428s8?',
        },
        network: 'twitter',
        color: '#31a1cd',
      },

      // {
      //   label: 'LinkedIn',
      //   path: 'org_75a949708670404p23s8g990/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=LKD',
      //   network: 'linkedin',
      //   custom_path: {
      //     us: 'org_a95ss6pp11s3ss020s73spa7/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=LKD',
      //     mx: 'org_15gr63156p2grs6a206p295a/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?fieldId=fid_6346pr61gg91pp0pp6a6g5s3&value=LKD',
      //   },
      //   color: '#2b69b0',
      // },
      // {
      //   label: 'Organic Social',
      //   path: 'org_75a949708670404p23s8g990/hierarchy/template-group/tgt_000331psa512p75a2rs512r3?',
      //   network: 'organic-social',
      //   color: '#89221b',
      // },
      {
        label: 'Other social',
        path: 'org_75a949708670404p23s8g990/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?',
        custom_path: {
          us: 'org_a95ss6pp11s3ss020s73spa7/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?',
          mx: 'org_15gr63156p2grs6a206p295a/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?',
          maz: 'org_041ap166r82p957197r91532/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?',
          eu: 'org_p453r3arps4s32gpr5gr4s1a/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?',
          co: 'org_70p6p7543178r35g49204259/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?',
          ca: 'org_2164r5gg20803g2552p73782/hierarchy/template-group/tgt_6185510p9s83a621grr7gs02?',
          br: 'org_75a949708670404p23s8g990/hierarchy/template-group/tgt_sag50280a0p1692as8a3rra7?',
          af: 'org_55s7671124gp60969g1a1191/hierarchy/template-group/tgt_7a167pg671p795p5385ars39?',
        },
        network: 'other',
        color: '#acacac',
      },
    ],
  },
  {
    label: 'Programmatic',
    children: [
      {
        label: 'DSP',
        path: 'org_75a949708670404p23s8g990/hierarchy/template-group/tgt_a666rrr9gp977685rr5p4564?',
        custom_path: {
          us: 'org_a95ss6pp11s3ss020s73spa7/hierarchy/template-group/tgt_a666rrr9gp977685rr5p4564?',
          mx: 'org_15gr63156p2grs6a206p295a/hierarchy/template-group/tgt_a666rrr9gp977685rr5p4564?',
          maz: 'org_041ap166r82p957197r91532/hierarchy/template-group/tgt_a666rrr9gp977685rr5p4564?',
          eu: 'org_p453r3arps4s32gpr5gr4s1a/hierarchy/template-group/tgt_a666rrr9gp977685rr5p4564?',
          co: 'org_70p6p7543178r35g49204259/hierarchy/template-group/tgt_a666rrr9gp977685rr5p4564?',
          ca: 'org_2164r5gg20803g2552p73782/hierarchy/template-group/tgt_a666rrr9gp977685rr5p4564?',
          br: 'org_83p342267235ap89969sg129/hierarchy/template-group/tgt_a666rrr9gp977685rr5p4564?',
          af: 'org_55s7671124gp60969g1a1191/hierarchy/template-group/tgt_a666rrr9gp977685rr5p4564?',
        },
        network: 'db',
        color: '#f59c20',
      },
    ],
  },
  {
    label: 'Ad Info',
    children: [
      {
        label: 'Ad Server',
        path: 'org_75a949708670404p23s8g990/hierarchy/template-group/tgt_169r02s0p90308g827pg2a89?',
        custom_path: {
          us: 'org_a95ss6pp11s3ss020s73spa7/hierarchy/template-group/tgt_169r02s0p90308g827pg2a89?',
          mx: 'org_15gr63156p2grs6a206p295a/hierarchy/template-group/tgt_169r02s0p90308g827pg2a89?',
          maz: 'org_041ap166r82p957197r91532/hierarchy/template-group/tgt_169r02s0p90308g827pg2a89?',
          eu: 'org_p453r3arps4s32gpr5gr4s1a/hierarchy/template-group/tgt_169r02s0p90308g827pg2a89?',
          co: 'org_70p6p7543178r35g49204259/hierarchy/template-group/tgt_169r02s0p90308g827pg2a89?',
          ca: 'org_2164r5gg20803g2552p73782/hierarchy/template-group/tgt_169r02s0p90308g827pg2a89?',
          br: 'org_83p342267235ap89969sg129/hierarchy/template-group/tgt_169r02s0p90308g827pg2a89?',
          af: 'org_55s7671124gp60969g1a1191/hierarchy/template-group/tgt_169r02s0p90308g827pg2a89?',
        },
        network: 'hardDrive',
        color: '#e5b612',
      },
    ],
  },
  // {
  //   label: 'Ad Info',
  //   children: [
  //     {
  //       label: 'Programmatic',
  //       path: 'org_75a949708670404p23s8g990/hierarchy/template-group/tgt_35srr0r12589as0r4r613s36?',
  //       custom_path: {
  //         us: 'org_a95ss6pp11s3ss020s73spa7/hierarchy/template-group/tgt_35srr0r12589as0r4r613s36?',
  //         mx: 'org_15gr63156p2grs6a206p295a/hierarchy/template-group/tgt_35srr0r12589as0r4r613s36?',
  //         maz: 'org_041ap166r82p957197r91532/hierarchy/template-group/tgt_35srr0r12589as0r4r613s36?',
  //         eu: 'org_p453r3arps4s32gpr5gr4s1a/hierarchy/template-group/tgt_35srr0r12589as0r4r613s36?',
  //         co: 'org_70p6p7543178r35g49204259/hierarchy/template-group/tgt_35srr0r12589as0r4r613s36?',
  //         ca: 'org_2164r5gg20803g2552p73782/hierarchy/template-group/tgt_35srr0r12589as0r4r613s36?',
  //         br: 'org_83p342267235ap89969sg129/hierarchy/template-group/tgt_35srr0r12589as0r4r613s36?',
  //         af: 'org_55s7671124gp60969g1a1191/hierarchy/template-group/tgt_35srr0r12589as0r4r613s36?',
  //       },
  //       network: 'hardDrive',
  //       color: '#c4232d',
  //     },
  //   ],
  // },
  {
    label: 'Extras',
    children: [
      {
        label: 'CRM',
        path: 'org_75a949708670404p23s8g990/hierarchy/template-group/tgt_481470r8s6ssga265r3p7333?',
        network: 'crm',
        color: '#451210',
      },
      {
        label: 'DTC Social',
        path: 'org_75a949708670404p23s8g990/hierarchy/template-group/tgt_rprs76r003p76r34g0rg2r78?',
        network: 'crm',
        color: '#451210',
      },
      {
        label: 'DTC Programmatic',
        path: 'org_75a949708670404p23s8g990/hierarchy/template-group/tgt_g6s19p67gp88g76r5g54pp92?',
        network: 'crm',
        color: '#451210',
      },
    ],
  },
];

window.chrome?.runtime?.sendMessage?.(
  'gnncjalmnfmdilagegplkkckngolohof',
  {
    action: 'getUser',
  },
  (result: boolean) => {
    logged.value = !!result;
  },
);
</script>

<style lang="sass" scoped>
main
  display: flex
  align-items: center
  flex-direction: column

  .item-network
    &:hover
      label
        font-weight: bold

  // .item-network
  //   img,
  //   label
  //     transition: transform 0.3s

  //   &:hover
  //     img
  //       transform: translateY(6px)

  //     label
  //       background: transparent !important
  //       color: #fff
  //       transform: translateY(-13px)

iframe
  padding: 0
  width: 100%
  height: 3000px
  border: 0
</style>
